<template>
  <div data-testid="file-master__view">
  <div class="all-height d-flex justify-center">
    <div class="all-width">
      <v-card :loading="loading" :disabled="loading" loader-height="2">
        <v-card-text class="pb-0">
          <div class="d-flex align-center">
            <v-btn rounded color="primary" elevation="0" class="mr-2" @click="addFileNames()" data-testid="file-master__add-btn">
              <v-icon class="mr-1">mdi-plus</v-icon><p>Add</p>
            </v-btn>
            <lb-string label="Search" outlined hidedetails v-model="seachList" data-testid="file-master__search-input"></lb-string>
            <v-spacer></v-spacer>
            <v-chip label class="border-left-error" outlined><p>Disabled</p></v-chip>
            <v-btn icon class="ml-2" @click="getData()" data-testid="file-master__refresh-btn">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-text>
          <lb-datatablenew :headers="headers" :items="searchResult" :enableslot="['action','bid']" :loading="loading" data-testid="file-master__datatable">
      <template v-slot:bid="{ item }">
        {{getBotName(item.bid)}}
      </template>
            <template v-slot:action="{ item }">
              <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="" @click="editfileMaster(item)" data-testid="file-master__edit-btn">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="" @click="ConfigfileMaster(item)" data-testid="file-master__config-btn">
                    <v-icon>mdi-file-link</v-icon>
                  </v-btn>
                </template>
                <span>File Config</span>
              </v-tooltip>
            </template>
          </lb-datatablenew>
        </v-card-text>
      </v-card>
    </div>
  </div>
  <lb-dialog v-model="dialogfile" width="600" :heading="fileDetails._id ? 'Update File' : 'Create File'" :loading="filemasterloading" data-testid="file-master__dialog">
    <template v-slot:body>
      <div>
        <div class="d-flex align-center justify-center">
          <v-row>
            <v-col cols="12" class="my-0 py-0">
              <lb-string label="File Name*" v-model="fileDetails.name" :error="fileDeatilserror.name" data-testid="file-master__name-input" /> 
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <lb-string label="Description" v-model="fileDetails.description" :error="fileDeatilserror.description" /> 
            </v-col>
            <v-col cols="6" class="my-0 py-0">
              <lb-string label="Alias" v-model="fileDetails.alias" :error="fileDeatilserror.alias"/>
            </v-col>
      <v-col cols="6" class="my-0 py-0">
               <lb-dropdown class="flux-grow-1 mr-1" :label="`Select ${$constants.BOT_NAME}*`" :items="botlist" v-model.trim="fileDetails.bid" itemtext="name" itemvalue="_id" :error="fileDeatilserror.bid" :key="new Date().getTime()"/>
            </v-col>
      <v-col cols="4" class="my-0 py-0">
             <v-checkbox label="Auto sync" class="mt-0 mr-4 info--text" dense v-model="fileDetails.sync" color="info" ></v-checkbox>       
            </v-col>
      <v-col cols="12" class="my-0 py-0" v-if="fileDetails.sync">
               <lb-dropdown class="flux-grow-1 mr-1" label="Operator*" :items="operationsList" v-model="fileDetails.operetor"  itemtext="name" itemvalue="id" :error="fileDeatilserror.operetor"/>
            </v-col>
      <v-col cols="12" class="my-0 py-0" v-if="fileDetails.sync">
               <lb-string label="Value*" v-model="fileDetails.operatorvalue"  :error="fileDeatilserror.operatorvalue"/>
            </v-col>
      <v-col cols="12" class="my-0 py-0" v-if="fileDetails.sync">
               <lb-string label="Bucket Name*" v-model="fileDetails.bucketName" :error="fileDeatilserror.bucketName"/>
            </v-col>
      <v-col cols="12" class="my-0 py-0" v-if="fileDetails.sync">
               <lb-dropdown class="flux-grow-1 mr-1" label="Operation Of File*" :items="asyncFile" v-model="fileDetails.uploadtype" :error="fileDeatilserror.uploadtype"/>
            </v-col>
          </v-row>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <span class="caption">*Required</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="fileDetails._id" @click="updatefileMaster(fileDetails._id)" data-testid="file-master__update-btn">
        <p>Update</p>
      </v-btn>
      <v-btn color="primary" v-else @click="addfileMaster()" data-testid="file-master__add-submit-btn">
        <p>Add</p>
      </v-btn>
    </template>
  </lb-dialog>
</div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      filemasterloading: false,
      dialogfile: false,
      fileDetails: {},
      fileDeatilserror: {},
      formatedData: [],
      headers: [{
          value: "indexno",
          text: "#",
          sortable: false,
          filterable: false,
        },
        {
          value: "name",
          text: "Name",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "description",
          text: "Description",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "alias",
          text: "Alias",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "bid",
          text: this.$constants.BOT_NAME,
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
          filterable: false,
        },
      ],
      getfiledata: [],
      botlist:[],
      operationsList:[{id:"startsWith",name:"Start With"},{id:"endsWith",name:"End With"},{id:"contains",name:"Contains"}],
      asyncFile:["New File","Replace"],
      seachList:'',
      copygetfiledata:[],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formateData() {
      let ObjectTemp = {};
      let ArrayTemp = [];
      this.getfiledata.forEach((i, k) => {
        ObjectTemp = {
          _id: i._id,
          indexno: k + 1,
          name: i.name,
          description: i.description,
          alias: i.alias,
          bid:i.bid,
        }
        ArrayTemp.push(ObjectTemp);
      });
      this.formatedData = ArrayTemp;
    },
    getBotName(id) {
      let bot = this.botlist.find((x) => x._id === id);
      return (bot || {}).name;
    },
    async getData() {
    this.loading = true;
    try {
      const fileMasterResponse = await this.axios.post("/v2/conserve/filemaster/get");
      if (fileMasterResponse.data.status === "success") {
      this.getfiledata = fileMasterResponse.data.data;
      this.formateData();
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.getBot();
      this.loading = false;
    }
    },
    getBot(){
      this.loading = true;
      return this.axios.post("v2/conserve/bot/get").then(dt => {
        if (dt.data.status === "success" && dt.data.data.length > 0) {
          this.botlist = dt.data.data;
        }
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      }).finally(() => {
        this.loading = false;
      })
    },
    addFileNames() {
      this.dialogfile = true;
      (this.fileDeatilserror = {}), 
      (this.fileDetails = {});
    },
    validateFileDetails(data = this.fileDetails) {
    const errors = {};
  
    // Helper function to check required fields
    const validateRequired = (field, fieldName, errorMessage) => {
      const value = data[field];
      // Check for undefined, null, empty string, or empty array (for specific fields)
      const isEmpty =
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === "") ||
        ((field === 'uploadtype' || field === 'operatorvalue' || field === 'operetor') && Array.isArray(value) && value.length === 0);
      if (isEmpty) {
        errors[field] = [errorMessage || `${fieldName} is required`];
      }
    };

    // Validate common required fields
    validateRequired('name', 'Name');
    validateRequired('bid', 'Bot');
    
    // Validate conditional fields only if sync is true
    if (data.sync) {
      validateRequired('uploadtype', 'Upload type');
      validateRequired('bucketName', 'Bucket name');
      validateRequired('operetor', 'operetor');
      validateRequired('operatorvalue', 'Operator value');
    }

    return errors;
  },

  buildFilePayload() {
    const {
      name,
      description,
      alias,
      bid,
      sync = false,
      uploadtype,
      bucketName,
      operetor,
      operatorvalue
    } = this.fileDetails;

    const payload = {
      name,
      description,
      alias,
      bid,
      sync
    };

    if (sync) {
      payload.uploadtype = uploadtype;
      payload.bucketName = bucketName;
      payload.operetor = operetor;
      payload.operatorvalue = operatorvalue;
    }

    return payload;
  },

  async addfileMaster() {
    this.fileDeatilserror = this.validateFileDetails();
    if (Object.keys(this.fileDeatilserror).length > 0) return;

    const data = this.buildFilePayload();
    this.filemasterloading = true;

    try {
      const response = await this.axios.post("/v2/conserve/filemaster/add", { data });

      if (response?.data?.status === "success") {
        this.$store.commit("sbSuccess", "File added successfully");
        this.getData();
        this.dialogfile = false;
      } else {
        const errData = response?.data?.data?.[0]?.index0;
        if (errData) {
          this.fileDeatilserror = errData;
        } else {
          throw new Error(response.data.message || "Unknown error");
        }
      }
    } catch (err) {
      this.$store.commit("sbError", err.message || "Unknown error!");
      console.error("Add File Error:", err);
    } finally {
      this.filemasterloading = false;
    }
  },

  async updatefileMaster(id) {
    this.fileDeatilserror = this.validateFileDetails();
    if (Object.keys(this.fileDeatilserror).length > 0) return;

    const data = this.buildFilePayload();
    this.filemasterloading = true;

    try {
      const response = await this.axios.post(`/v2/conserve/filemaster/edit/${id}`, { data });

      if (response?.data?.status === "success") {
        this.$store.commit("sbSuccess", "File updated successfully");
        this.getData();
        this.dialogfile = false;
      } else {
        const errData = response?.data?.data?.[0]?.index0;
        if (errData) {
          this.fileDeatilserror = errData;
        } else {
          throw new Error(response.data.message || "Unknown error");
        }
      }
    } catch (err) {
      this.$store.commit("sbError", err.message || "Unknown error!");
      console.error("Update File Error:", err);
    } finally {
      this.filemasterloading = false;
    }
  },


    editfileMaster(item) {
      (this.fileDeatilserror = {}), 
      this.dialogfile = true;
      this.fileDetails = {
        ...item
      };
    },
    
    ConfigfileMaster(item) {
      this.$nova.gotoLink({
        path: 'filemaster/config/' + item._id
      })
    }
  },
  computed: {
    searchResult() {
      let tempList = this.getfiledata;
      if (this.seachList != "" && this.seachList) {
        tempList = tempList.filter((item) => {
          return item.name.toUpperCase().includes(this.seachList.toUpperCase());
        });
      }

      return tempList;
    },
  },
};
</script>